import objects from "../data/objectDefinitions";
import { IOData, SimData } from "../types";
import { ObjectDefinitions } from "../types/ObjectDefinitionTypes";

class dataLoader {
  private static instance: dataLoader;
  private constructor() {
    //Intentionally blank
  }

  public static getInstance() {
    if (!this.instance) this.instance = new dataLoader();
    return this.instance;
  }

  loadData() {
    //Loads data from file
  }

  loadDatafromJSon(data: any): IOData[] {
    const objectDefinitions: ObjectDefinitions[] = [];
    const simObjects: SimData[] = [];

    objects.map((item) => {
      objectDefinitions.push(item);
    });

    data.default.objects.map((item: SimData) => {
      //console.log(item);
      simObjects.push(item);
    });

    const allItems: IOData[] = [];

    simObjects.map((item1) => {
      const matchingItems = objectDefinitions.filter(
        (item2) => item2.name === item1.name
      );

      const items: IOData[] = [];
      matchingItems.map((matchingItem) => {
        const temp = { ...matchingItem, ...item1 };
        if (item1.states && matchingItem.states) {
          temp.states = [
            ...item1.states.map((state) => {
              if (!matchingItem.states) return state;
              const matchingState = matchingItem.states?.find(
                (mState) => mState.name == state.name
              );
              return { ...state, ...matchingState };
            }),
            ...matchingItem.states.filter(
              (s) => !item1.states?.map((st) => st.name).includes(s.name)
            ),
          ];
        }
        items.push(temp);
      });

      allItems.push(...items);
    });
    return allItems;
  }

  loadExampleData() {
    const objectDefinitions: ObjectDefinitions[] = [];
    const simObjects: SimData[] = [];

    objects.map((item) => {
      objectDefinitions.push(item);
    });

    const allItems: IOData[] = [];

    objectDefinitions.map((item1) => {
      const matchingItems = simObjects.filter(
        (item2) => item2.name === item1.name
      );

      const items: IOData[] = [];
      matchingItems.map((matchingItem) => {
        const temp = { ...item1, ...matchingItem };
        items.push(temp);
      });

      allItems.push(...items);
    });

    return allItems;
  }
}

export default dataLoader;
